import config from './config.js';

import LoginPage from '../components/auth/login.f7.html';
import SignUpPage from '../components/auth/signup.f7.html'
import VerificationPage from '../components/auth/verify.f7.html'
import AdminPage from '../components/admin/data.f7.html';

const routes = [];

/*
|------------------------------------------------------------------------------
| Home Route (/)
|------------------------------------------------------------------------------
*/

routes.push(
    {
        path: '/',
        async({ resolve }) {

            if (config.navigation.splash.enabled) {
              console.log('SplashPage');
                resolve({ component: '/pages/splash.f7.html' });
            } else if (config.navigation.walkthrough.enabled) {
              console.log('WalkthroughPage');
                resolve({ component: '/pages/walkthrough.f7.html' });
            } else if (config.navigation.authentication.required && !config.navigation.authentication.guestAccess) {
              console.log('LoginPage');
                resolve({ component: LoginPage });
            } else if (config.layout.default == 'singleView' && config.layout.singleView.tabbar.enabled) {
              console.log('Tabbar');
                resolve({ component: '/pages/tabbar.f7.html' });
            } else {
              console.log('HomePage');
                resolve({ component: '/pages/home.f7.html' });
            }
        }
    },
    {
        path: '/walkthrough',
        component: '/pages/walkthrough.f7.html'
    },
    {
        path: '/main',
        component: '/pages/main.f7.html'
    },
    {
        path: '/login',
        component: LoginPage
    },
    {
        path: '/signup',
        component: SignUpPage
    },
    {
        path: '/verify',
        component: VerificationPage
    },
    {
        path: '/sidebar',
        component: '/pages/sidebar.f7.html'
    },
    {
        path: '/settings',
        component: '/pages/settings.f7.html'
    },
    {
        path: '/admin',
        component: AdminPage
    }
);

/*
|------------------------------------------------------------------------------
| Tabbar Routes (For Single View Layout)
|------------------------------------------------------------------------------
*/

if (config.layout.default == 'singleView' && config.layout.singleView.tabbar.enabled) {
    routes.push({
        path: '/',
        alias: ['/home'],
        component: '/pages/tabbar.f7.html',
        tabs: [{
            id: 'tab-home',
            path: '/',
            component: '/pages/home.f7.html',
        },
        {
            id: 'tab-karyakram',
            path: '/karyakram',
            component: '/pages/karyakram.f7.html',
        }
        ]
    });
}

routes.push({
    path: '/karyakram',
    component: '/pages/karyakram.f7.html',
    routes: [
        {
            path: '/mgms',
            componentUrl: '/pages/mgms/mgms.f7.html'
        },
        {
            path: '/mgms/step1',
            componentUrl: '/pages/mgms/step1.f7.html',
        },
        {
            path: '/mgms/step2',
            componentUrl: '/pages/mgms/step2.f7.html',
        },
        {
            path: '/mgms/step3',
            componentUrl: '/pages/mgms/step3.f7.html',
        },
        {
            path: '/mgms/step4',
            componentUrl: '/pages/mgms/step4.f7.html',
        },
        {
            path: '/mgms/step5',
            componentUrl: '/pages/mgms/step5.f7.html',
        },
        {
            path: '/mgms/step6',
            componentUrl: '/pages/mgms/step6.f7.html',
        },
    ]
});



routes.push({
    path: '(.*)',
    component: '/pages/error.f7.html'
});

export default routes;